import { render } from "./B2bFilterButtonGenralsReceived.vue?vue&type=template&id=708b9c94&scoped=true&lang=pug"
import script from "./B2bFilterButtonGenralsReceived.vue?vue&type=script&lang=js"
export * from "./B2bFilterButtonGenralsReceived.vue?vue&type=script&lang=js"

import "./B2bFilterButtonGenralsReceived.vue?vue&type=style&index=0&id=708b9c94&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-708b9c94"]])

export default __exports__